module.exports = __webpack_public_path__ + "static/media/(980503).8f918a4f.jpg";